import React from 'react';
import { Button } from '@/components/ui/button';
import { X, Link2, Copy, Check } from 'lucide-react';

/**
 * ShareModal - Modal for sharing design preview links
 * Extracted from DesignPreviewPage.js
 */
const ShareModal = ({
  isOpen,
  onClose,
  shareUrl,
  onCopy,
  copied,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6" data-testid="share-modal">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-bold text-zinc-900">Share Design</h3>
          <button 
            onClick={onClose} 
            className="p-2 hover:bg-zinc-100 rounded-lg"
            data-testid="share-modal-close"
          >
            <X className="w-5 h-5 text-zinc-500" />
          </button>
        </div>
        <p className="text-zinc-600 mb-4">Anyone with this link can view your design.</p>
        <div className="flex items-center gap-2 mb-4">
          <div className="flex-1 flex items-center gap-2 bg-zinc-100 rounded-lg px-4 py-3 border">
            <Link2 className="w-4 h-4 text-zinc-400" />
            <input 
              type="text" 
              value={shareUrl} 
              readOnly 
              className="flex-1 bg-transparent text-sm outline-none"
              data-testid="share-url-input"
            />
          </div>
          <Button 
            onClick={onCopy} 
            className={copied ? 'bg-green-600' : 'bg-indigo-600'}
            data-testid="copy-share-url-btn"
          >
            {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
